import React, { useEffect, useState, useCallback } from "react";
import Layout from "../../../components/Layouts/Layouts/Layout";
import Layout2 from "../../../components/Layouts/Layouts/Layout2";
import DashboardHeader from "../../../components/basic/DashboardHeader";
import { Card, Button, Badge, Spinner, Row, Col, Modal } from "react-bootstrap";
import { getURLbyEndPoint } from "../../../store/api";
import axios from "axios";
import { getAuthUserlocal } from "../../../store/services";
import { IoTime, IoLocationSharp, IoArrowBack } from "react-icons/io5";
import { FaVideo } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useAuth } from "../../../context/auth";
import { PopUpModalButton } from "../../../components/basic/fileViewModel";

const AecciIacEvents = () => {
  const [events, setEvents] = useState([]);
  const [registeredEvents, setRegisteredEvents] = useState([]);
  const [view, setView] = useState("all"); // 'all' or 'registered'
  const [loading, setLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const [registering, setRegistering] = useState(false);
  const [eventToRegister, setEventToRegister] = useState(null);
  const navigate = useNavigate();
  const [auth] = useAuth();

  const fetchAllEvents = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(getURLbyEndPoint("getAllEvents"));
      setEvents(response.data);
    } catch (error) {
      console.error("Error fetching events:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchRegisteredEvents = useCallback(async () => {
    setLoading(true);
    try {
      const userId = auth?.user || getAuthUserlocal()?._id;
      if (!userId) {
        toast.error("User session not found. Please login again.");
        return;
      }
      const response = await axios.get(
        getURLbyEndPoint("getRegisterEvent") + userId,
      );
      setRegisteredEvents(response.data);
    } catch (error) {
      console.error("Error fetching registered events:", error);
    } finally {
      setLoading(false);
    }
  }, [auth?.user]);

  useEffect(() => {
    if (view === "all") {
      fetchAllEvents();
    } else {
      fetchRegisteredEvents();
    }
  }, [view, fetchAllEvents, fetchRegisteredEvents]);

  const handleOpenRegisterModal = (event) => {
    setEventToRegister(event);
    setShowRegisterModal(true);
  };

  const handleDirectRegister = async () => {
    if (!eventToRegister) return;
    setRegistering(true);
    try {
      const user = getAuthUserlocal();
      const userId = auth?.user || user?._id || user?.id;

      const payload = {
        eventId: eventToRegister._id,
        title: eventToRegister.title,
        eventType: eventToRegister.eventType,
        eventDate: eventToRegister.eventDate,
        eventTime: eventToRegister.eventTime,
        fee: eventToRegister.fee,
        description: eventToRegister.description,
        eventUrl: eventToRegister.joiningLink || "",
        location: eventToRegister.location,
        heading: eventToRegister.heading || eventToRegister.title,
        email: user?.email,
        name: `${user?.firstName || ""} ${user?.surName || ""}`.trim(),
        numberOfParticipant: 1,
        totalAmt: eventToRegister.fee || 0,
        joiningLink: eventToRegister.joiningLink,
      };

      const response = await axios.post(
        getURLbyEndPoint("registerEvent") + userId,
        payload,
      );

      if (response.status === 201 || response.data.status) {
        toast.success("Registration request submitted successfully!");
        setShowRegisterModal(false);
        fetchRegisteredEvents();
        setView("registered");
        setSelectedEvent(null);
      } else {
        toast.error(response.data.message || "Registration failed.");
      }
    } catch (error) {
      console.error("Error registering for event:", error);
      toast.error(
        error.response?.data?.message || "Error submitting registration.",
      );
    } finally {
      setRegistering(false);
    }
  };

  const handleJoinMeeting = (event) => {
    const meetingId =
      event.meetingId ||
      (event.joiningLink && event.joiningLink.split("/").pop());
    if (meetingId) {
      const userName =
        getAuthUserlocal().firstName + " " + (getAuthUserlocal().surName || "");
      const joinUrl = `/meeting-room/${meetingId}?name=${encodeURIComponent(
        userName.trim(),
      )}`;
      navigate(joinUrl);
    } else {
      alert("Meeting link not available yet.");
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return {
      day: date.getDate(),
      month: date.toLocaleString("default", { month: "short" }),
      year: date.getFullYear(),
    };
  };

  function convertTo12HourFormat(time) {
    if (!time) return "N/A";
    const [hours, minutes] = time.split(":").map(Number);
    const timeObj = new Date();
    timeObj.setHours(hours, minutes);
    return timeObj.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  }

  const EventCard = ({ event, isRegistered }) => {
    const { day, month } = formatDate(event.eventDate);
    return (
      <Col md={6} className="mb-4">
        <Card
          className="h-100 border-0 shadow-sm hover-shadow-lg transition-all cursor-pointer"
          style={{
            borderRadius: "12px",
            border: "1px solid #eee",
            backgroundColor: "#fff",
          }}
          onClick={() => setSelectedEvent(event)}
        >
          <Card.Body className="p-4">
            <div className="d-flex justify-content-between align-items-start mb-3">
              <div
                className="text-center bg-light rounded p-2"
                style={{ minWidth: "60px" }}
              >
                <div className="fw-bold h4 mb-0 text-success">{day}</div>
                <div className="small text-uppercase text-muted">{month}</div>
              </div>
              {isRegistered && (
                <Badge
                  bg={event.isApproved === "Approved" ? "success" : "warning"}
                  className="rounded-pill px-3"
                >
                  {event.isApproved}
                </Badge>
              )}
            </div>

            <h5 className="fw-bold mb-2 text-dark line-clamp-2">
              {event.title}
            </h5>

            <p className="text-muted small mb-3 line-clamp-3">
              {event.description}
            </p>

            <div className="d-flex flex-column gap-2 text-muted small mb-3">
              <div className="d-flex align-items-center">
                <IoTime className="me-2 text-success" />
                <span>{convertTo12HourFormat(event.eventTime)} onwards</span>
              </div>
              <div className="d-flex align-items-center">
                <IoLocationSharp className="me-2 text-success" />
                <span>{event.location}</span>
              </div>
            </div>

            <div className="mt-auto pt-3 border-top d-flex justify-content-between align-items-center">
              <span className="text-success small fw-bold">View Details →</span>
              {!isRegistered ? (
                !event.isRegistrationClosed ? (
                  <Button
                    variant="outline-success"
                    size="sm"
                    className="rounded-pill px-3"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleOpenRegisterModal(event);
                    }}
                  >
                    Register
                  </Button>
                ) : (
                  <Badge bg="secondary" className="rounded-pill px-3 py-2">
                    Closed
                  </Badge>
                )
              ) : event.isRegistrationClosed && event.certificate ? (
                <div onClick={(e) => e.stopPropagation()}>
                  <PopUpModalButton
                    title="Download Certificate"
                    fileLink={event.certificate}
                    variant="info"
                  />
                </div>
              ) : (
                event.isApproved === "Approved" &&
                !event.isRegistrationClosed && (
                  <Button
                    variant="success"
                    size="sm"
                    className="rounded-pill px-3"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleJoinMeeting(event);
                    }}
                  >
                    Join Room
                  </Button>
                )
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>
    );
  };

  const EventDetail = ({ event }) => {
    const { day, month, year } = formatDate(event.eventDate);
    const isRegistered = view === "registered";

    return (
      <div className="bg-white p-4 rounded-3 shadow-sm border animate__animated animate__fadeIn">
        <Button
          variant="link"
          className="text-decoration-none text-muted mb-4 d-flex align-items-center p-0"
          onClick={() => setSelectedEvent(null)}
        >
          <IoArrowBack className="me-2" /> Back to Events
        </Button>

        <Row>
          <Col lg={8}>
            <div className="d-flex align-items-center gap-3 mb-4">
              <div
                className="bg-success text-white rounded p-3 text-center"
                style={{ minWidth: "80px" }}
              >
                <h2 className="mb-0 fw-bold">{day}</h2>
                <div className="text-uppercase small">{month}</div>
              </div>
              <div>
                <h3 className="fw-bold mb-1">{event.title}</h3>
                <div className="text-muted">{year}</div>
              </div>
            </div>

            <div className="mb-4">
              <h5 className="fw-bold mb-3">About the Event</h5>
              <p
                className="text-secondary"
                style={{ lineHeight: "1.8", whiteSpace: "pre-wrap" }}
              >
                {event.description}
              </p>
            </div>

            <Row className="mb-4 g-3">
              <Col sm={6}>
                <div className="p-3 bg-light rounded-3 d-flex align-items-center">
                  <IoTime className="fs-4 text-success me-3" />
                  <div>
                    <div className="small text-muted">Time</div>
                    <div className="fw-bold">
                      {convertTo12HourFormat(event.eventTime)}
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={6}>
                <div className="p-3 bg-light rounded-3 d-flex align-items-center">
                  <IoLocationSharp className="fs-4 text-success me-3" />
                  <div>
                    <div className="small text-muted">Location</div>
                    <div className="fw-bold">{event.location} - Zoom</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>

          <Col lg={4}>
            <div className="sticky-top" style={{ top: "2rem" }}>
              <Card className="border-0 shadow-sm bg-light">
                <Card.Body className="p-4 text-center">
                  <h6 className="fw-bold mb-4">Event Registration</h6>
                  {isRegistered &&
                  event.isRegistrationClosed &&
                  event.certificate ? (
                    <div className="w-100 mb-3">
                      <PopUpModalButton
                        title="Download Certificate"
                        fileLink={event.certificate}
                        variant="info"
                      />
                    </div>
                  ) : isRegistered &&
                    event.isApproved === "Approved" &&
                    !event.isRegistrationClosed ? (
                    <Button
                      variant="success"
                      className="w-100 py-3 fw-bold rounded-pill mb-3"
                      onClick={() => handleJoinMeeting(event)}
                    >
                      <FaVideo className="me-2" /> Join Meeting Room
                    </Button>
                  ) : !isRegistered && !event.isRegistrationClosed ? (
                    <Button
                      variant="success"
                      className="w-100 py-3 fw-bold rounded-pill mb-3"
                      onClick={() => handleOpenRegisterModal(event)}
                    >
                      Register Now
                    </Button>
                  ) : (
                    <Button
                      variant="secondary"
                      disabled
                      className="w-100 py-3 rounded-pill mb-3"
                    >
                      {event.isRegistrationClosed
                        ? "Registration Closed"
                        : `Status: ${event.isApproved}`}
                    </Button>
                  )}
                  <p className="small text-muted mb-0">
                    Registration for this event is mandatory to access materials
                    and meeting links.
                  </p>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <Layout>
      <Layout2>
        <DashboardHeader heading="EVENTS / AECCI-IAC EVENTS" />
        <div className="px-3 pb-5">
          {!selectedEvent && (
            <>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-4 mb-4 gap-3">
                <h4
                  className="fw-bold text-uppercase mb-0"
                  style={{ letterSpacing: "1px" }}
                >
                  AECCI-IAC Events
                </h4>
                <div
                  className="bg-light p-1 rounded-pill d-flex gap-1"
                  style={{ width: "fit-content" }}
                >
                  <Button
                    variant={view === "all" ? "success" : "link"}
                    className={`px-4 py-2 fw-bold rounded-pill text-decoration-none ${
                      view === "all" ? "text-white shadow-sm" : "text-muted"
                    }`}
                    onClick={() => setView("all")}
                    size="sm"
                  >
                    All Events
                  </Button>
                  <Button
                    variant={view === "registered" ? "success" : "link"}
                    className={`px-4 py-2 fw-bold rounded-pill text-decoration-none ${
                      view === "registered"
                        ? "text-white shadow-sm"
                        : "text-muted"
                    }`}
                    onClick={() => setView("registered")}
                    size="sm"
                  >
                    Registered
                  </Button>
                </div>
              </div>

              <hr className="mb-4" />

              {loading ? (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="success" />
                </div>
              ) : (
                <Row className="g-4">
                  {(view === "all" ? events : registeredEvents).map(
                    (event, index) => (
                      <EventCard
                        key={event._id || index}
                        event={event}
                        isRegistered={view === "registered"}
                      />
                    ),
                  )}
                  {(view === "all" ? events : registeredEvents).length ===
                    0 && (
                    <Col xs={12}>
                      <div className="text-center py-5 bg-white border rounded shadow-sm">
                        <h4 className="text-muted fw-light">No events found</h4>
                      </div>
                    </Col>
                  )}
                </Row>
              )}
            </>
          )}

          {selectedEvent && <EventDetail event={selectedEvent} />}
        </div>

        {/* Registration Confirmation Modal */}
        <Modal
          show={showRegisterModal}
          onHide={() => setShowRegisterModal(false)}
          centered
          className="montserratFont"
        >
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title className="fw-bold text-success fs-4">
              Event Registration
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-3 px-4">
            <div className="mb-4">
              <h5 className="fw-bold mb-2">"{eventToRegister?.title}"</h5>
              <div className="d-flex gap-3 text-muted small">
                <span>
                  <IoTime className="me-1 text-success" />{" "}
                  {eventToRegister?.eventTime}
                </span>
                <span>
                  <IoLocationSharp className="me-1 text-success" />{" "}
                  {eventToRegister?.location}
                </span>
              </div>
            </div>

            <p className="text-secondary small" style={{ lineHeight: "1.6" }}>
              We will use your existing profile details (Name, Organization,
              Contact Info) to process this registration. This request will be
              sent to the AECCI team for approval.
            </p>

            {eventToRegister?.fee > 0 && (
              <div className="alert alert-info py-2 rounded-0 border-0 small">
                <strong>Note:</strong> This event has a fee of ₹
                {eventToRegister.fee}. Further instructions will be shared after
                approval.
              </div>
            )}
          </Modal.Body>
          <Modal.Footer className="border-0 pt-0 px-4 pb-4">
            <Button
              variant="light"
              className="rounded-pill px-4"
              onClick={() => setShowRegisterModal(false)}
              disabled={registering}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              className="rounded-pill px-4 shadow-sm"
              onClick={handleDirectRegister}
              disabled={registering}
            >
              {registering ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Processing...
                </>
              ) : (
                "Confirm & Register"
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </Layout2>
      <style>{`
        .hover-shadow-lg:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1) !important;
        }
        .transition-all {
          transition: all 0.3s ease;
        }
        .cursor-pointer {
          cursor: pointer;
        }
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .line-clamp-3 {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </Layout>
  );
};

export default AecciIacEvents;
